import React, { useEffect, useState } from "react";
import { Input, Modal, Select, Checkbox } from "antd";
import FloatLabel from "../../../../../../components/FloatLabel";
import { ErrorMessage, triggerNotification, useGetApiRequests } from "../../../../../../common/CommonExport";
import ImageUpload from "../../../../../Dashboard/AddEmployeeModal/imageUpload/ImageUpload";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import "./uploadEmployeeDocument.scss";
import Loader from "../../../../../../components/Loader/Loader";
import { setDocumentLoad } from "../../../../../../redux/slices/updateProfileSlice";
import ModalLoader from "../../../../../../components/Loader/ModalLoader";
import { Field } from "formik";
import { is } from "immutable";

interface DocumentItem {
  documentTypeId: string;
  name: string;
  isActive: boolean;
  isMandatory: boolean;
  documentCode: string | null;
}

export const DOCUMENT_TYPES = {
  OTHERS: "Others",
} as const;

const UploadEmployeeDocument = (props: any) => {
  const { id }: any = useParams();
  const dispatch = useDispatch();
  const employeeDocumentTypes = useGetApiRequests("documentType", "GET");
  const employeeDocumentUpload = useGetApiRequests("documentUpload", "POST");

  const orgId = useSelector((state: any) => state?.organisationId?.id);
  const [open, setOpen] = useState(false);
  const [documentType, setDocumentType] = useState("");
  const [documentList, setDocumentList] = useState<DocumentItem[]>([]);
  const [documentCodeList, setDocumentCodeList] = useState<string[]>([]);
  console.log("🚀 ~ UploadEmployeeDocument ~ documentCodeList:", documentCodeList)

  const [customDocName, setCustomDocName] = useState("");
  const [documentCode, setDocumentCode] = useState("");
  const [mediaData, setMediaData] = useState<any>(new FormData());
  const [showError, setShowError] = useState<any>(false);
  const [isOthers, setIsOthers] = useState<boolean>(false);
  const [duplicateError, setDuplicateError] = useState(false);
  const [duplicateCodeError, setDuplicateCodeError] = useState(false);

  const [isVisibleToEmployee, setIsVisibleToEmployee] = useState<boolean>(false);

  const [imgCheck, setImgCheck] = useState<any>(false);
  const [loader, setLoader] = useState<any>(false);

  useEffect(() => {
    setOpen(props?.open);

    employeeDocumentTypes()
      .then((res: any) => {
        const documents: DocumentItem[] = res?.data?.data || [];
        setDocumentList(documents);


        const codes = documents
          .map((doc: DocumentItem) => doc.documentCode)
          .filter((code: string | null): code is string => !!code);

        setDocumentCodeList(codes);
      })
      .catch((err: any) => {
        console.error(err);
      });
  }, []);


  const handleClose = () => {
    setOpen(false);
    props?.setUploadDocument(false);
  };

  const handleChange = (value: string) => {
    const selectedOption = documentList.find(
      (doc) => doc.documentTypeId === value
    );


    const selectedName = selectedOption?.name ?? "";


    setIsOthers(selectedName === DOCUMENT_TYPES.OTHERS);

    setDocumentType(value);
  };

  const handleImageUpload = (file: any) => {
    setImgCheck(true);
    const formData = new FormData();
    Array.isArray(file) ? file.forEach((f: any) => formData.append("files", f?.originFileObj || f)) : formData.append("files", file?.originFileObj || file);
    setMediaData(formData);
  };

  const handleImageDelete = (file: File) => {
    setImgCheck(false);
    setMediaData("");
  };

  const handleAddDocument = () => {
    if (documentType?.length === 0 || !imgCheck || (isOthers && customDocName.trim() === "") || duplicateError || (isOthers && documentCode.trim() === "") || duplicateCodeError || (isOthers && (documentCode.length < 4 || documentCode.length > 8))
    ) {
      setShowError(true);
      return;
    }
    finalSubmit();
  };
  const onChangeDocName = (value: string) => {
    setCustomDocName(value);
    if (value.trim() === "") {

      setDuplicateError(false);
      return;
    }


    const exists = documentList.some(
      (doc) => doc.name.toLowerCase() === value.trim().toLowerCase()
    );
    setDuplicateError(exists);
  };

  const onChangeDocCode = (value: string) => {
    const onlyLetters = value.replace(/[^A-Za-z]/g, "");
    const upper = onlyLetters.toUpperCase();
    const trimmed = upper.slice(0, 8);
    setDocumentCode(trimmed);
    const exists = documentCodeList.includes(trimmed);
    setDuplicateCodeError(exists);
  }

  const finalSubmit = () => {
    setLoader(true);
    const documentDto = {
      documentDto: {
        documentTypeId: documentType,
        employeeId: parseInt(id),
        organisationId: orgId,
        ...(isOthers ? { folderName: customDocName, code: documentCode, isVisibleToEmployee: isVisibleToEmployee, } : {}),
      },
    };
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    employeeDocumentUpload(mediaData, documentDto, {}, headers)
      .then((res: any) => {
        setLoader(false);

        triggerNotification("success", "", res?.data?.message, "topRight");
        handleClose();
        props?.getDocumentApiData();
        dispatch(setDocumentLoad());
      })
      .catch((err: any) => {
        setLoader(false);
        console.log(err);
      });
  };

  return (
    <Modal title="Upload Document" centered open={open} onCancel={() => handleClose()} footer={null} className="modal-uploadDocument" maskClosable={false}>
      {loader && <ModalLoader />}
      <div className="py-4 documentUpload upload">
        <div className="form-item select-width ">
          <FloatLabel label="Document Type *" name="documentType" value={documentType}>
            <Select
              className="float-control "
              onChange={(value: any) => handleChange(value)}
              showSearch
              value={documentType}
              filterOption={(input: any, option: any) => option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0}
            >
              {documentList?.map((option: any) => (
                <Select.Option key={option.documentTypeId} value={option.documentTypeId}>
                  {option.name}
                </Select.Option>
              ))}
            </Select>
          </FloatLabel>
          {showError && documentType?.length === 0 && (
            <div className="pl-2">
              <ErrorMessage message="Please select a document type" />
            </div>
          )}

        </div>
        {isOthers && (
          <div className="grid grid-cols-12 gap-4 mt-4">
            <div className="col-span-12 md:col-span-6">
              <FloatLabel label="Enter Document Name *" name="customDocName" value={customDocName}>
                <Input
                  value={customDocName}
                  onChange={(e) => onChangeDocName(e.target.value)}
                  className="float-control"
                  placeholder=""
                />
              </FloatLabel>
              {showError && customDocName.trim() === "" && (
                <div className="pl-2">
                  <ErrorMessage message="Document name is required" />
                </div>
              )}

              {duplicateError && (
                <div className="pl-2">
                  <ErrorMessage message="Document name already exists" />
                </div>
              )}

            </div>



            <div className="col-span-12 md:col-span-6">
              <FloatLabel label="Enter Document Code *" name="DocumentCode" value={documentCode}>
                <Input
                  value={documentCode}
                  onChange={(e) => onChangeDocCode(e.target.value)}
                  className="float-control"
                  placeholder=""
                />
              </FloatLabel>
              {showError && documentCode.trim() === "" && (
                <div className="pl-2">
                  <ErrorMessage message="Document code is required" />
                </div>
              )}
              {duplicateCodeError && (
                <div className="pl-2">
                  <ErrorMessage message="Document code already exists" />
                </div>
              )}
              {showError && documentCode?.length > 0 && (documentCode?.length < 4 || documentCode?.length > 8) && (
                <div className="pl-2">
                  <ErrorMessage message="Code must be 4–8 characters" />
                </div>
              )}


            </div>
          </div>
        )}
        {isOthers && (
          <div className="mt-4 pl-2">
            <Checkbox
              checked={isVisibleToEmployee}
              onChange={(e) => setIsVisibleToEmployee(e.target.checked)}
            >
              Allow employee to view this document


            </Checkbox>
          </div>
        )}

        <div className="form-item">
          <div className="mt-4 pt-4">
            <ImageUpload
              multiple={true}
              onImageUpload={handleImageUpload}
              onImageDelete={handleImageDelete}
              maxFileSize={1024 * 1024 * 10}
              allowedTypes={["image/jpeg", "image/png", "application/pdf"]}
            />
          </div>
          {showError && !imgCheck && (
            <div className="pl-1">
              <ErrorMessage message="Document is required" />
            </div>
          )}

        </div>
        <div className="flex justify-end mt-8">
          <button className="addButton secondary mr-5" onClick={() => handleClose()}>
            Cancel
          </button>
          <button className="addButton" onClick={() => handleAddDocument()}>
            Add
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadEmployeeDocument;
